import Close from '../../assets/icons/Close'
import Modal from '../Modal'

interface LogoutModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

const LogoutModal = ({ isOpen, onConfirm, onCancel }: LogoutModalProps) => {
  if (!isOpen) return null

  return (
    <Modal open={isOpen} close={onCancel}>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
        <div className="bg-white p-6 rounded-[10px]  w-[673px] h-[198px] shadow-xl">
          <div className="flex justify-between">
            <h2 className="text-xl font-semibold mb-6">Logout</h2>
            <div className="text-[#ADB5BD]" onClick={onCancel}>
              <Close />
            </div>
          </div>
          <p className="mb-6 text-[#6C757D] font-medium text-lg">
            Are you sure you want to logout?
          </p>
          <hr className="-mx-6 border-t border-[#DEE2E6]" />
          <div className="flex justify-end space-x-2 mt-4">
            <button
              onClick={onCancel}
              className="px-4 py-2 rounded border border-[#CED4DA]"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 rounded bg-[#9C191B] text-white"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default LogoutModal
